// XXX: Do we really need polyfills for compatibility with old browsers?
import 'core-js/stable'
import 'shared/ada_tab'

import Modernizr from 'modernizr'
window.Modernizr = Modernizr

import 'jquery-ui/ui/widget'
import 'jquery-ui/ui/disable-selection'
import 'jquery-ui/ui/effect'
import 'jquery-ui/ui/keycode'
import 'jquery-ui/ui/tabbable'
import 'jquery-ui/ui/widgets/autocomplete'
import 'jquery-ui/ui/widgets/datepicker'
import 'jquery-ui/ui/widgets/draggable'
import 'jquery-ui/ui/widgets/droppable'
import 'jquery-ui/ui/widgets/slider'
import 'jquery-ui/ui/widgets/sortable'

import 'jquery-ui-touch-punch/jquery.ui.touch-punch.min.js'
import 'foundation-sites/js/entries/foundation'
